<template>
  <div class="training-detail-bottom-bar-component">
    <row-item type="gradient-primary"
              size="medium"
              v-if="isOfflineTraining && isMember"
              @click="handleShowQrCode"
    >
      加入训练营微信群
    </row-item>
    <row-item type="primary-light"
              size="medium"
              v-else-if="isMember"
              @click="handleShowCalendar"
    >
      查看我的计划
    </row-item>

    <template v-else>
      <bottom-bar class="audio-detail-bottom-bar"
                  :benefit-bar="benefitBar"
                  :sell="sell"
                  :product="product"
                  :render-price="renderPrice"
                  :action-bar="actionBar"
                  :my-team-id="myTeamId"
                  :row-btn-round="joinBtnRound"
      />
    </template>
  </div>
</template>

<script>
  import RowItem from '@/components/YmTabbarItem/Row';
  import validator from '@/utils/validator';
  import BottomBar from '@/components/ProductDetailBottom/Bar';

  export default {
    name: 'TrainingDetailBottomBar',
    components: {
      RowItem,
      BottomBar,
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      sell: {
        type: Object,
        required: true,
      },
      isMember: {
        type: Boolean,
        required: true,
      },
      benefitBar: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      renderPrice: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      actionBar: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      primaryPrice: {
        type: Object,
        required: true,
      },
      myTeamId: {
        type: Number,
        default: 0,
      },
      joinBtnRound: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      isOfflineTraining() {
        const { type } = this;
        return type === 'offline';
      },
      product() {
        return { type: 'reading', id: this.id, price: this.primaryPrice.origin.value };
      },
    },
    methods: {
      handleShowQrCode() {
        this.$emit('qr-code');
      },
      handleShowCalendar() {
        this.$emit('joined');
      },
      handleDisabledJoin() {
        this.$emit('disabled-join');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .training-detail-bottom-bar-component {
    flex: 1;
    display: flex;
  }

  .training-price-container {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: @font-size-medium;
    font-weight: @font-weight-light;
    .text {
      margin-right: @size-small;
    }
  }

  .training-price {
    display: flex;
    align-items: flex-end;
    line-height: 1;
    &-active {
      font-size: @font-size-large;
      font-weight: @font-weight-primary;
      /deep/ .price-unit {
        margin-right: @size-extra-small / 2;
        font-size: @font-size-large;
        line-height: 1.1;
      }
    }
    &-del {
      font-size: @font-size-base;
      /deep/ .price-unit {
        margin-left: @size-extra-small / 2;
        font-size: @font-size-base;
        line-height: 1;
      }
    }
  }

  .training-price-del-container {
    margin-left: @size-small;
    display: flex;
    align-items: flex-end;
    color: @training-text-white-lighter;
    font-size: @font-size-base;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      left: -1px;
      right: -2px;
      bottom: 40%;
      display: block;
      height: 1px;
      background-color: @training-text-white-lighter;
    }
  }
</style>
